/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSalesRepRevenueRankingFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type SalesRepRevenueRanking } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/sales-reps/top-by-revenue
 */
export interface TopByRevenueRequestBuilder extends BaseRequestBuilder<TopByRevenueRequestBuilder> {
    /**
     * Ranks sales reps by the revenue on the orders recorded as taken by them in the period, highest first. Only orders that carry a rep are counted, so self-service orders placed by customers themselves are left out entirely and the column deliberately falls short of total revenue — this is a leaderboard, not a reconciliation. Rep details are the snapshot taken when the order was placed rather than the rep record as it stands now, so a rep who has since changed name or left still appears as they were. averageItemsPerOrder counts distinct lines on the order, not units. Both date bounds are inclusive; a period with no rep-attributed orders returns an empty array.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SalesRepRevenueRanking[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<TopByRevenueRequestBuilderGetQueryParameters> | undefined) : Promise<SalesRepRevenueRanking[] | undefined>;
    /**
     * Ranks sales reps by the revenue on the orders recorded as taken by them in the period, highest first. Only orders that carry a rep are counted, so self-service orders placed by customers themselves are left out entirely and the column deliberately falls short of total revenue — this is a leaderboard, not a reconciliation. Rep details are the snapshot taken when the order was placed rather than the rep record as it stands now, so a rep who has since changed name or left still appears as they were. averageItemsPerOrder counts distinct lines on the order, not units. Both date bounds are inclusive; a period with no rep-attributed orders returns an empty array.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TopByRevenueRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Ranks sales reps by the revenue on the orders recorded as taken by them in the period, highest first. Only orders that carry a rep are counted, so self-service orders placed by customers themselves are left out entirely and the column deliberately falls short of total revenue — this is a leaderboard, not a reconciliation. Rep details are the snapshot taken when the order was placed rather than the rep record as it stands now, so a rep who has since changed name or left still appears as they were. averageItemsPerOrder counts distinct lines on the order, not units. Both date bounds are inclusive; a period with no rep-attributed orders returns an empty array.
 */
export interface TopByRevenueRequestBuilderGetQueryParameters {
    /**
     * End of the period, inclusive. Compared against the order date as a full timestamp, so adate with no time stops at midnight; it must not be earlier than the start date.
     */
    endDate?: Date;
    /**
     * How many rows to return, taken from the top of the ranking. Defaults to 10; there is nopaging, so raise this rather than trying to page past the cut-off.
     */
    limit?: number;
    /**
     * Start of the period, inclusive. Compared against the order date as a full timestamp.
     */
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const TopByRevenueRequestBuilderUriTemplate = "{+baseurl}/api/analytics/sales-reps/top-by-revenue?endDate={endDate}&limit={limit}&startDate={startDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TopByRevenueRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TopByRevenueRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createSalesRepRevenueRankingFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
